import { render, staticRenderFns } from "./APlaceList.vue?vue&type=template&id=1781d5ac&scoped=true"
import script from "./APlaceList.vue?vue&type=script&lang=js"
export * from "./APlaceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1781d5ac",
  null
  
)

export default component.exports